export const dictionary = {
  rph: 'RPH',
  itineraryInfo: {
    name: 'Itinerary Info',
    reservationsItems: {
      name: 'Reservation Item',
      rph: 'RPH:',
      flightSegment: {
        name: 'Flight Segment',
        action: 'Action:',
        arrivalDateTime: 'Arrival Date Time:',
        connectionInd: 'Connection Ind:',
        departureDateTime: 'Departure Date Time:',
        eTicket: 'Eticket:',
        flightNumber: 'Flight Number:',
        numberInParty: 'Number In Party:',
        resBookDesigCode: 'RES Book Desig Code:',
        status: 'Status:',
        destinationLocation: {
          name: 'Destination Location',
          locationCode: 'Location Code:'
        },
        originLocation: {
          name: 'Origin Location',
          locationCode: 'Location Code:'
        },
        marketingAirline: {
          name: 'Marketing Airline',
          code: 'Code:',
          flightNumber: 'Flight Number:'
        },
        supplierRef: {
          name: 'Supplier Ref',
          id: 'ID:'
        }
      }
    },
    itineraryRef: {
      name: 'Itinerary Ref',
      accountingCity: 'Accounting City:',
      accountingCode: 'Accounting Code:',
      officeStationCode: 'Office Station Code:',
      ticketingCarrier: 'Ticketing Carrier:',
      source: {
        name: 'Source',
        aaA_PseudoCityCode: 'AAA Pseudo City Code:',
        createDateTime: 'Create Date Time:',
        creationAgent: 'Creation Agent:',
        creationAgentDutyCode: 'Creation Agent Duty Code:',
        creationAgentFunctionCode: 'Creation Agent Function Code:',
        pseudoCityCode: 'Pseudo City Code:',
        receivedFrom: 'Received From:'
      }
    }
  },
  historyInfo: {
    Title: 'History'
  },
  nameForHistory: [
    {
      name: 'titleForHistory.specialServices',
      code: '*SPP'
    },
    {
      name: 'titleForHistory.ancillaries',
      code: '*AN'
    },
    {
      name: 'titleForHistory.passenger',
      code: '*H3'
    },
    {
      name: 'titleForHistory.history',
      code: '*H'
    },
    {
      name: 'titleForHistory.remarks',
      code: '*H5'
    },
    {
      name: 'titleForHistory.remarks',
      code: '*P5'
    },
    {
      name: 'titleForHistory.seatMap',
      code: '4G1*'
    },
    {
      name: 'titleForHistory.ticketField',
      code: '*T'
    },
    {
      name: 'titleForHistory.pre-ReservedSeats',
      code: '*B'
    },
    {
      name: 'titleForHistory.pre-ReservedSeats',
      code: '*B'
    },
    {
      name: 'titleForHistory.emailAddress',
      code: '*PE'
    },
    {
      name: 'titleForHistory.names',
      code: '*N'
    },
    {
      name: 'titleForHistory.priceQuotes',
      code: '*PQ'
    },
    {
      name: 'titleForHistory.historyItinerary',
      code: '*HI'
    },
    {
      name: 'titleForHistory.Itinerary',
      code: '*I'
    },
    {
      name: 'titleForHistory.Seats',
      code: '*HB'
    }
  ],
  generalInfo: {
    name: 'General Info',
    action: 'Action:',
    text: 'Text:'
  },
  accountingInfo: {
    name: 'Accounting Info',
    item: 'Accounting Item',
    action: 'Action:',
    specialService: 'Special Service',
    email: 'email',
    baseFareAmount: 'Base Fare Amount:',
    baseFareCurrencyCode: 'Base Fare Currency Code:',
    documentInfo: 'Document Info:',
    paymentInfoCommission: 'Payment Info Commission:',
    fareApplication: 'Fare Application:',
    paymentForm: 'Payment Form:',
    nameNumber: 'Name Number:',
    personName: 'Person Name:',
    taxes: {
      name: 'Taxes',
      gstCurrencyCode: 'GST Currency Code:',
      qstCurrencyCode: 'QST Currency Code:',
      taxAmount: 'Tax Amount:',
      taxCurrencyCode: 'Tax Currency Code:'
    },
    ticketingInfo: {
      name: 'Ticketing Info',
      exchangeInd: 'Exchange Ind:',
      tarriffBasis: 'Tarriff Basis:',
      ticketingConjunctedCount: 'Ticketing Conjuncted Count:',
      Tkt: 'tkt',
      Pay: 'Pay',
      seats: 'Seats',
      Remarks: 'Remarks'
    }
  }
};
